import axios from 'axios';

async function ObtenerUbicacionesSancor( prmBuscar: string) {
    
    if (prmBuscar.trim().length < 3) {
        return [];
    }

    const url = "https://endpoints.mapsys.com.ar/gestion/sancor_obtener_ubicaciones";
    
    try {
        //const response = await axios.get(url);

        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "filtro": prmBuscar.trim()
        });
        
        return response.data;
    } catch (error) {
 
        return error;
    }
};

export default ObtenerUbicacionesSancor;